import { governmentBusinessReducer } from './government-business.reducer'
import { initializeReducer } from './initialize.reducer'
import { authReducer } from './auth.reducer'
import { queryReducer } from './query.reducer'
import { activityReducer } from './activity.reducer'
import { knowledgeReducer } from './knowledge.reducer'
import { dashboardReducer, entityWiseReducer } from './dashboard.reducer'
import { employeeReducer } from './employee.reducer'
import { announcementReducer } from './announcement.reducer'
import { settingsReducer } from './settings.reducer'
import { calendarReducer } from './calendar.reducer'
import { commonReducer } from './common.reducer'
import { offlineTrackerReducer } from './offline-tracker.reducer'
import { onboardingReducer } from './onboarding.reducer'
import { companySettingsReducer } from './company-settings.reducer'

export const appReducer = {
  login: authReducer,
  activity: activityReducer,
  initialize: initializeReducer,
  governmentBusiness: governmentBusinessReducer,
  query: queryReducer,
  knowledge: knowledgeReducer,
  dashboard: dashboardReducer,
  employee: employeeReducer,
  announcement: announcementReducer,
  settings: settingsReducer,
  calendar: calendarReducer,
  common: commonReducer,
  offlineTracker: offlineTrackerReducer,
  entityWiseData: entityWiseReducer,
  onboarding: onboardingReducer,
  companySettings: companySettingsReducer
}
